import { Button } from "@/components/ui/button";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { OverflowDisplayTooltip } from "@/components/ui/Tooltip/OverflowDisplayTooltip";
import { XIcon } from "@heroicons/react/outline";
import { XCircleIcon } from "@heroicons/react/solid";
import { observer } from "mobx-react-lite";
import { useEffect, useRef, useState } from "react";
import { MessageStore } from "./message-store";

const MessageParsingError = ({ message }: { message: MessageStore }) => {
  const { parsingError } = message;
  const [show, setShow] = useState<boolean>(!!parsingError);
  const prevParsingError = useRef<string | undefined>(parsingError);

  useEffect(() => {
    if (prevParsingError.current !== parsingError) {
      prevParsingError.current = parsingError;
      setShow(!!parsingError);
    }
  }, [parsingError]);

  if (!show) return null;

  return (
    <div className="absolute bottom-2 left-2 z-50 flex w-auto max-w-[98%] items-center gap-2 rounded-md bg-red-500/90 px-2 py-1 text-xs text-white shadow-sm backdrop-blur-sm">
      <XCircleIcon className="h-3 w-3 flex-shrink-0" />
      <OverflowDisplayTooltip content={parsingError} className="min-w-0 flex-1">
        {parsingError}
      </OverflowDisplayTooltip>
      <BasicTooltip content="Dismiss">
        <Button
          onClick={() => setShow(false)}
          variant={"destructiveLink"}
          size="tinyIcon"
          className="h-4 w-4 p-0 text-white/80 hover:text-white"
        >
          <XIcon className="h-3 w-3" />
        </Button>
      </BasicTooltip>
    </div>
  );
};

export default observer(MessageParsingError);
